module.exports = __webpack_public_path__ + "static/media/Tube.e0a454fb.png";